"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
function SvgMapOutline(props) {
    return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 32 32" }, props),
        React.createElement("path", { d: "M25 9v2h3v14H4V11h3V9H2v18h28V9h-5z" }),
        React.createElement("path", { d: "M15.31 19.72l.69.66.69-.66c.22-.2 5.31-5.12 5.31-10.27C22 5.29 19.87 3 16 3s-6 2.29-6 6.45c0 5.15 5.09 10.07 5.31 10.27zM16 5c2.77 0 4 1.37 4 4.45 0 3.27-2.7 6.65-4 8.1-1.3-1.45-4-4.83-4-8.1C12 6.42 13.27 5 16 5z" }),
        React.createElement("circle", { cx: 16, cy: 9.5, r: 1.5 })));
}
exports.default = SvgMapOutline;
//# sourceMappingURL=MapOutline.js.map